module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-03-5005e0d254c54f9582361f91b168390d.jpg";